//this closure ensures we won't be interfering with other libraries that have defined $
(function($) {
    var issueTrackingTable = {};
    var jiraProjectsTemplate = {};
    var jiraIssuesTemplate = {};
    var fieldRowsTemplate = {};
    var tableHeaderTemplate = {};
    var tableFillerTemplate = {};
    var nameEdited = false;
    var serverEdited = false;
    var userIdEdited = false;
    var passwordEdited = false;
    var issueTrackingNames = null;
    var originalName = null;
    var nameEdited = false;
    var serverEdited = false;
    var userIdEdited = false;
    var passwordEdited = false;
    var testing = false;
    var testingInProgress = false;
    var connectionPassed = false;
    var systemProjectInfo = null;
    var selectedType = null;
    var selectedProjectInfo = null;
    var selectedRowData = null;
    var errorResources = new ResourceHelper('com.compuware.resources.ErrorResources');
    var JIRA = 'JIRA';
    var DATE_FORMAT = 'YYYY-MM-DDThh:mm:ss:SSSZ';
    var currentIssueTrackingUser = null;
    var currentIssueTrackingServer = null;
     
    var encryptPassword = function(data) {
        if (!!data.password) {
            var encrypted = Crypto.encrypt(data.password);
            data.a = encrypted.iv;
            data.b = encrypted.encrypted;
            delete data.password;
        }
        
        return data;
    };
    
    var encryptServer = function(data) {
        if (!!data.server) {
            var encryptedserver = Crypto.encrypt(data.server);
            data.c = encryptedserver.iv;
            data.d = encryptedserver.encrypted;
            delete data.server;
        }
        
        return data;
    };
    
    var decryptPassword = function(data) {
        if (data.a && data.b) {
            // Decrypt the password
            data.password = Crypto.decrypt(data.a, data.b);
            delete data.a;
            delete data.b;
        }
        
        return data;
    };
    
    var handleFieldValueSelected = function(event) {
        var $currentTarget = $(event.currentTarget);
        var $row = $currentTarget.closest('tr');
        
        if (!$currentTarget.hasClass('use-custom')) {
            $row.find('.custom-values input');
            $row.find('.custom-values input').attr('disabled', 'disabled');
            $row.find('.custom-values input[type="text"]').removeClass('invalid');
            $row.find('.custom-values select').attr('disabled', 'disabled');
            $.clearStatus();
        } else {
            $row.find('.custom-values input').removeAttr('disabled');
            var $customTextField = $row.find('.custom-values input[type="text"]');
            
            if ($customTextField.length > 0 && $customTextField.val().trim().length === 0) {
                $customTextField.addClass('invalid');
                $.showErrorStatus(fieldRequiredErrorText);
            }
            
            $row.find('.custom-values select').removeAttr('disabled');
        }
        
        if (!$currentTarget.hasClass('use-field')) {
            $row.find('.field-values select').attr('disabled', 'disabled');
        } else {
            $row.find('.field-values select').removeAttr('disabled');
        }
    };
    
    var handleProjectChanged = function(event) {
        var projectID = $('#jiraProjects').val();
        
        for (var index = 0; index < systemProjectInfo.length; index++) {
            var project = systemProjectInfo[index];
            
            if (!!project.id && project.id === projectID) {
                $('#jiraIssuesContainer').remove();
                $('#stepTwoContents').append(Mustache.to_html(jiraIssuesTemplate, {issues: project.issueTypeArray}));
                break;
            }
        }
    };
    
    var validateTextField = function($textField, $row) {
        var validationError = null;
        var value = $textField.val();
        
        if ($row.hasClass('required') && (value.trim().length === 0)) {
            validationError = fieldRequiredErrorText
        } else if (value.trim().length > 0) {
            if ($textField.hasClass('number')) {
                try {
                    if (!/^\d*\.?\d*$/.test(value)) {
                        validationError = numericErrorText;
                    }
                } catch (error) {
                    validationError = numericErrorText;
                }
            } else if ($textField.hasClass('date')) {
                try {
                    var date = moment(value, DATE_FORMAT);
                    
                    if (!date.isValid()) {
                        date = moment(new Date(value));
                    }
                    
                    if (!date.isValid()) {
                        validationError = dateErrorText;
                    }
                } catch (error) {
                    validationError = dateErrorText;
                }
            }
        }
        
        return validationError;
    };
    
    var validateCustomTextField = function(event) {
        var $currentTarget = $(event.currentTarget);
        var $currentRow = $currentTarget.closest('tr');
        var validationError = validateTextField($currentTarget, $currentRow);;
        
        if (!!validationError) {
            $currentTarget.addClass('invalid');
            $.showErrorStatus(validationError);
        } else {
            $currentTarget.removeClass('invalid');
            $.clearStatus();
        }
    };
    
    var addRow = function(data) {
        $.displayLoadingIndicator(addingText);
        data = encryptPassword(data);
        
        currentIssueTrackingUser = null;
        currentIssueTrackingServer = null;
        
       $.ajax({
            type: 'POST',
            url : 'settings/addIssueTrackingSystem',
            data : data,
            dataType : 'json',
            cache : false
        }).done(function(response) {
            if (!!response.success) {
                data = decryptPassword(data);
                data.projectInfo = JSON.parse(data.projectInfo);
                data.fieldMappings = JSON.parse(data.fieldMappings);
                issueTrackingTable.row.add(data);
                issueTrackingTable.draw();
            } else {
                
            }
        }).always(function() {
            $.removeLoadingIndicator();
        });
    };
    
    var updateRow = function(data) {
        $.displayLoadingIndicator(updatingText);
        data = encryptPassword(data);
        data.originalName = originalName;
        
        currentIssueTrackingUser = null;
        currentIssueTrackingServer = null;
        
        $.ajax({
            type: 'POST',
            url : 'settings/updateIssueTrackingSystem',
            data : data,
            dataType : 'json',
            cache : false
        }).done(function(response) {
            if (!!response.success) {
                var selectedRow = issueTrackingTable.$('tr.row_selected')[0];
                data = decryptPassword(data);
                data.projectInfo = JSON.parse(data.projectInfo);
                data.fieldMappings = JSON.parse(data.fieldMappings);
                issueTrackingTable.row('tr.row_selected').data(data);
            }
        }).always(function() {
            $.removeLoadingIndicator();
        });
    };
 
    var deleteSelectedRows = function() {
        $.displayLoadingIndicator(deletingText);
        
        var names = [];
        var rowData = issueTrackingTable.rows('.row_selected').data();

        currentIssueTrackingUser = null;
        currentIssueTrackingServer = null;
        
        for (var index = 0; index < rowData.length; index++) {
            names.push(rowData[index].name);
        }
        
        $.ajax({
            type: 'POST',
            url : 'settings/deleteIssueTrackingSystem',
            data : {names : names},
            dataType : 'json',
            cache : false
        }).done(function(response) {
            if (!!response.IssueTrackingSystemInfoResponse) {
                var systemInfoList = response.IssueTrackingSystemInfoResponse.IssueTrackingSystemInfoList;

                if (systemInfoList.length > 0) {
                    issueTrackingTable.rows('.row_selected').remove();
                    issueTrackingTable.draw();
                }
            }
        }).always(function() {
            $.removeLoadingIndicator();
        });             
    };
    
    var showIssueTrackingWizard = function() {
        var $wizard = $('#issueTrackingWizard');
        
        $wizard.steps({
            headerTag : "h1",
            bodyTag : "section",
            enableCancelButton : true,
            showFinishButtonAlways : true,
            transitionEffect : "slideLeft",
            onCanceled : closeWizard,
            onStepChanging : stepChanging,
            onStepChanged : stepChanged,
            onFinishing : wizardFinishing,
            onFinished : wizardFinished
        });
        
        var tableData = issueTrackingTable.rows().data();
        issueTrackingNames = [];
        
        for (var index = 0; index < tableData.length; index++) {
            issueTrackingNames.push(tableData[index].name);
        }
        
        if ($(this).attr('id') === 'issueTrackingEditButton') {
            selectedRowData = issueTrackingTable.row('.row_selected').data();
            originalName = selectedRowData.name;
            
            if (!!selectedRowData.name) {
                $('#issueTrackingName').val(selectedRowData.name);
            }
            
            if (!!selectedRowData.type) {
                $('#issueTrackingType').val(selectedRowData.type);
            }

            if (!!selectedRowData.server) {
                $('#issueTrackingServer').val(selectedRowData.server);
            }
            
            if (!!selectedRowData.userID) {
                $('#issueTrackingUserID').val(selectedRowData.userID);
            }
        }
        
        $('#issueTrackingName').on('input', validateName);
        $('#issueTrackingName').on('focusin', validateName);
        
        $('#issueTrackingServer').on('input', validateServer);
        $('#issueTrackingServer').on('focusin', validateServer);

        $('#issueTrackingUserID').on('input', validateUserID);
        $('#issueTrackingUserID').on('focusin', validateUserID);

        $('#issueTrackingPassword').on('input', validatePassword);
        $('#issueTrackingPassword').on('focusin', validatePassword);

        $('#issueTrackingWizard input').on('click', function(event){event.stopPropagation();});
        $('#issueTrackingWizard li').on('click', function(event){event.stopPropagation();});
        $("html").on("click", function(){$.clearStatus();});
        
        var inputElements = $('#issueTrackingWizard input[type="text"]');
        inputElements.placeholder();
        
        var $finishButton = $('a[href="#finish"]').parent();
        $finishButton.addClass('invalid');
        $finishButton.attr('aria-disabled', 'true');
        
        $wizard.fadeIn('fast');
    };
    
    var closeWizard = function(event) {
        issueTrackingNames = null;
        originalName = null;
        nameEdited = false;
        serverEdited = false;
        userIdEdited = false;
        passwordEdited = false;
        systemProjectInfo = null;
        selectedType = null;
        selectedProjectInfo = null;
        selectedRowData = null;
        
        var $wizard = $('#issueTrackingWizard');
        $('#issueTrackingName').off('input');
        $('#issueTrackingName').off('focusin');
        
        $('#issueTrackingServer').off('input');
        $('#issueTrackingServer').off('focusin');

        $('#issueTrackingUserID').off('input');
        $('#issueTrackingUserID').off('focusin');

        $('#issueTrackingPassword').off('input');
        $('#issueTrackingPassword').off('focusin');
        
        $('.wizard .invalid').removeClass('invalid');
        $('#stepTwoContents').empty();
        clearFieldMappingsTable();
        $.clearStatus();
        
        $wizard.fadeOut('fast');
        $wizard.steps('destroy');
    };
    
    var getData = function() {
        var data = {
            name : $('#issueTrackingName').val().trim(),
            type : $('#issueTrackingType').val().trim(),
            server : $('#issueTrackingServer').val().trim(),
            userID : $('#issueTrackingUserID').val().trim(),
            password : $('#issueTrackingPassword').val().trim()
        };
        
        data.projectInfo = JSON.stringify(getProjectInfo());
        
        //get the field mappings
        var fieldMappings = [];
        var $fieldMappingRows = $('#fieldMappingsTable tbody tr');
        
        for (var index = 0; index < $fieldMappingRows.length; index++) {
            var $row = $($fieldMappingRows[index]);
            
            if (!$row.hasClass('pseudo-header-row') && !$row.hasClass('filler-row')) {
                var $fieldNameElement = $row.find('.field-name');
                var fieldKey = $fieldNameElement.attr('data-field-key');
                var fieldName = $fieldNameElement.html();
                var findAndFixField = null;
                var fieldValue = null;
                var useDefaultValue = false;
                var $selectedRadioButton = $('input[name="' + fieldKey + 'ValueGroup"]:checked');
                
                if ($selectedRadioButton.hasClass('use-default')) {
                    useDefaultValue = true;
                }
                
                if ($selectedRadioButton.hasClass('use-field')) {
                    findAndFixField = $('select[name="' + fieldKey + 'FixRequestValues"] option:selected').val();
                }
                
                if ($selectedRadioButton.hasClass('use-custom')) {
                    var $customTextField = $('#' + fieldKey + 'CustomTextField');
                    
                    if ($customTextField.length > 0) {
                        fieldValue = $customTextField.val();
                        
                        if ($customTextField.hasClass('date') && fieldValue.trim().length > 0) {
                            var date = moment(fieldValue, DATE_FORMAT);
                            
                            if (!date.isValid()) {
                                date = moment(new Date(fieldValue));
                            }
                            
                            fieldValue = fieldValue + '|||' + date.format(DATE_FORMAT);
                        }
                    } else {
                        fieldValue = $('#' + fieldKey + 'CustomValues').val();
                    }
                }
                
                fieldMappings.push({
                    fieldKey : fieldKey, 
                    fieldName : fieldName,
                    findAndFixField : findAndFixField,
                    fieldValue : fieldValue,
                    useDefaultValue : useDefaultValue
                });
            }
        }
        
        data.fieldMappings = JSON.stringify(fieldMappings);
        
        return data;
    };
    
    var getProjectInfo = function() {
        var projectInfo = {};
        var type = $('#issueTrackingType').val().trim();
        
        if (type === JIRA) {
            var $jiraProjects = $('#jiraProjects option:selected');
            var $jiraIssues = $('#jiraIssues option:selected');
            projectInfo.projectKey = $jiraProjects.attr('data-project-key');
            projectInfo.project = $jiraProjects.text();
            projectInfo.issueTypeID = $jiraIssues.val();
            projectInfo.issueType = $jiraIssues.text();
        }
        
        return projectInfo;
    };
    
    var testConnection = function(action) {
        testing = true;
        var data = getData();
        data = encryptPassword(data);
        data = encryptServer(data);
        $.displayLoadingIndicator(loadingText);
        
        $.ajax({
            type: 'GET',
            url : 'settings/testIssueTrackingSystem',
            data : data,
            dataType : 'json',
            cache : false
        }).done(function(response) {
            if (!!response.success) {
                connectionPassed = true;
                var $wizard = $('#issueTrackingWizard');
                $wizard.steps(action);
            } else {
                $.removeLoadingIndicator();
                var message = errorResources.getValue(response.reasonCode + '') + '<br/><br/>' + errorResources.getValue('connection.error.title') + ':<br/><i>' + "Server Connection test failed. " + '</i>';
                $.showMessageDialog({
                    title: errorResources.getValue('connection.error.title'),
                    message: message,
                    dialogID: '#errorDialog',
                    width: 'auto'
                });
                
                connectionPassed = false;
            }
        }).always(function() {
            testing = false;
        });
    };
    
    var validateSteps = function(currentIndex, action) {
        var valid = true;
        
        if (currentIndex === 0) {
            valid = validateStepOne();
            
            if (valid) {
                //the fields are valid so test the connection
                if (!connectionPassed) {
                    testConnection(action);
                    
                    if (testing) {
                        valid = false;
                    }
                }
                
                valid = !!connectionPassed;
                
                if (valid) {
                    //if the step is now valid then reset the connection flag
                    connectionPassed = false;
                }
            }
        } else if (currentIndex === 1) {
        } else if (currentIndex === 2) {
        }
        
        return valid;
    };
    
    var stepChanging = function(event, currentIndex, newIndex) {
        var valid = validateSteps(currentIndex, 'next');
        
        if (currentIndex === 2) {
            //leaving the field mappings step
            $('.wizard > .content > .body').css('position', 'absolute');
        } else {
            var $finishButton = $('a[href="#finish"]').parent();
            $finishButton.addClass('invalid');
            $finishButton.attr('aria-disabled', 'true');
        }
        
        return valid;
    };
    
    var stepChanged = function(event, currentIndex, priorIndex) {
        if (currentIndex === 1) {
            var issueTrackingType = $('#issueTrackingType').val().trim();
            var issueTrackingServer = $('#issueTrackingServer').val().trim();
            var issueTrackingUser = $('#issueTrackingUserID').val().trim();
            
            if (issueTrackingUser !== currentIssueTrackingUser || issueTrackingServer !== currentIssueTrackingServer) {
                $('#stepTwoContents').empty();
             	selectedType = issueTrackingType;
            	currentIssueTrackingUser = issueTrackingUser;
            	currentIssueTrackingServer = issueTrackingServer;
            	
            	var encryptedTrackingServer = Crypto.encrypt(issueTrackingServer);
                var trackingServerIV = encryptedTrackingServer.iv;
                var trackingServerENC = encryptedTrackingServer.encrypted;
                
                if (issueTrackingType === JIRA) {
                    $.displayLoadingIndicator(loadingText);
                    
                    $.ajax({
                        type: 'GET',
                        url : 'settings/getIssueProjectsAndTypes',
                        dataType : 'json',
                        data : {type: issueTrackingType, a: trackingServerIV, b: trackingServerENC, userID: issueTrackingUser},
                        cache : false
                    }).done(function(response) {
                        if (!!response) {
                            systemProjectInfo = response;
                            var projects = [];
                            var issues = [];
                            
                            for (var index = 0; index < systemProjectInfo.length; index++) {
                                var project = systemProjectInfo[index];
                                
                                if (!!project && !!project.id) {
                                    var projectSelected = false;
                                    
                                    if (!!selectedRowData && !!selectedRowData.projectInfo) {
                                        var projectInfo = selectedRowData.projectInfo;
                                        
                                        if (projectInfo.project === project.name) {
                                            projectSelected = true;
                                            //we need to clear the issues array because it might
                                            //have been populated with the first project information
                                            issues = [];
                                        }
                                    }
                                    
                                    projects.push({
                                        id: project.id,
                                        key: project.key,
                                        name: project.name,
                                        selected: projectSelected
                                    });
                                    
                                    if (index === 0 || projectSelected) {
                                        var issueTypeArray = project.issueTypeArray;

                                        for (var issueIndex = 0; issueIndex < issueTypeArray.length; issueIndex++) {
                                            var issue = issueTypeArray[issueIndex];
                                            var issueSelected = false; 
                                            
                                            if (!!selectedRowData && !!selectedRowData.projectInfo) {
                                                var projectInfo = selectedRowData.projectInfo;
                                                
                                                if (projectInfo.issueType === issue.name) {
                                                    issueSelected = true;
                                                }
                                            }
                                            
                                            issues.push({
                                                id: issue.id,
                                                name: issue.name,
                                                selected: issueSelected
                                            });
                                        }
                                    }
                                }
                            }
                            
                            $('#stepTwoContents').append(Mustache.to_html(jiraProjectsTemplate, {projects: projects}));
                            $('#stepTwoContents').append(Mustache.to_html(jiraIssuesTemplate, {issues: issues}));
                            $('#jiraProjects').on('change', handleProjectChanged);
                        }
                    }).always(function() {
                        $.removeLoadingIndicator();
                    });
                } else {
                    $.removeLoadingIndicator();
                }
            } else {
                $.removeLoadingIndicator();
            }
        } else  if (currentIndex === 2) {
            //arrived at the field mappings step
            $('.wizard > .content > .body').css('position', 'relative');            

            //get the fields/values
            var projectInfo = getProjectInfo();
            var projectInfoChanged = false;
            
            if (selectedProjectInfo !== null) {
                for (var property in projectInfo) {
                    if (projectInfo[property] !== selectedProjectInfo[property]) {
                        projectInfoChanged = true;
                        break;
                    }
                }
            } else {
                projectInfoChanged = true;
            }
            
            if (projectInfoChanged) {
                selectedProjectInfo = projectInfo;
                clearFieldMappingsTable();
                var data = getData();
                data = encryptPassword(data);
                
                $.displayLoadingIndicator(loadingText);
                
                $.ajax({
                    type: 'GET',
                    url : 'settings/getIssueTrackingFields',
                    dataType : 'json',
                    data : data,
                    cache : false
                }).done(function(response) {
                    var temporaryFieldData = response.fields;
                    var requiredData = [];
                    var optionalData = []
                    var issueTrackingType = $('#issueTrackingType').val().trim();
                    
                    for (var property in temporaryFieldData) {
                        var fieldData = temporaryFieldData[property];
                        var fieldType = fieldData.schema.type !== 'array' ? fieldData.schema.type : fieldData.schema.items;
                        
                        var templateData = {
                            fieldKey: fieldData.key,
                            fieldName: fieldData.name,
                            hasDefaultValue: fieldData.hasDefaultValue
                        };
                        
                        if (!!fieldData.allowedValues) {
                            var allowedValues = fieldData.allowedValues;
                            var values = [];
                            
                            if (!fieldData.required) {
                                values.push({
                                    id: 'ignore-value',
                                    name: ''
                                });
                            }
                            
                            for (var valueIndex = 0; valueIndex < allowedValues.length; valueIndex++) {
                                var value = allowedValues[valueIndex];
                                
                                if (!!value) {
                                    values.push({
                                        id: value.id,
                                        name: !!value.name ? value.name : value.value
                                    });
                                }
                            }
                            
                            templateData.allowedValues = {values: values};
                        }
                        
                        templateData.issueTrackingType = issueTrackingType;
                        
                        if (fieldType !== 'date' && fieldType !== 'number') {
                            fieldType = 'string'
                        }
                        
                        templateData.fieldType = fieldType;
                        
                        if (!!fieldData.required) {
                            templateData.required = true;
                            requiredData.push(templateData);
                        } else {
                            optionalData.push(templateData);
                        }
                    }
                    
                    var $fieldMappingsTable = $('#fieldMappingsTable tbody');
                    
                    $fieldMappingsTable.append(Mustache.to_html(tableHeaderTemplate, {fieldType : requiredHeaderText + ' ' + issueTrackingType + ' ' + fieldsHeaderText}));
                    $fieldMappingsTable.append(Mustache.to_html(fieldRowsTemplate, {rowData: requiredData}));
                    $fieldMappingsTable.append(Mustache.to_html(tableFillerTemplate, {}));
                    $fieldMappingsTable.append(Mustache.to_html(tableHeaderTemplate, {fieldType : optionalHeaderText + ' ' + issueTrackingType + ' ' + fieldsHeaderText}));
                    $fieldMappingsTable.append(Mustache.to_html(fieldRowsTemplate, {rowData: optionalData}));
                    
                    $fieldMappingsTable.find('input[type="radio"]').on('click', handleFieldValueSelected);
                    
                    if (!!selectedRowData && !!selectedRowData.fieldMappings) {
                        var fieldMappings = selectedRowData.fieldMappings;
                        
                        for (var index = 0; index < fieldMappings.length; index++) {
                            var field = fieldMappings[index];
                            var fieldKey = field.fieldKey;
                            
                            if (!!field.useDefaultValue) {
                                $('#' + fieldKey + 'UseDefault').click();
                            } else if (!!field.findAndFixField) {
                                $('#' + fieldKey + 'UseField').click();
                                $('#' + fieldKey + 'FixRequestList').val(field.findAndFixField);
                            } else if (!!field.fieldValue) {
                                var $customTextField = $('#' + fieldKey + 'CustomTextField');
                                var fieldValue = field.fieldValue;
                                
                                if ($customTextField.length > 0) {
                                    if ($customTextField.hasClass('date')) {
                                        fieldValue = fieldValue.substring(0, fieldValue.indexOf('|||'));
                                    }
                                    
                                    $customTextField.val(fieldValue);
                                } else {
                                    $('#' + fieldKey + 'CustomValues').val(fieldValue);
                                }
                                
                                $('#' + fieldKey + 'UseCustom').click();
                            }
                        }
                    }
                    
                    var $textFields = $fieldMappingsTable.find('input[type="text"]');
                    $textFields.on('focus', validateCustomTextField);
                    $textFields.on('keyup', validateCustomTextField);
                }).always(function() {
                    $.removeLoadingIndicator();
                }); 
            }
        }

        var $finishButton = $('a[href="#finish"]').parent();
        
        if (currentIndex !== 2) {
            $finishButton.addClass('invalid');
            $finishButton.attr('aria-disabled', 'true');
        } else {
            $finishButton.removeClass('invalid');
            $finishButton.attr('aria-disabled', 'false');
        }
    };
    
    var wizardFinishing = function(event, currentIndex) {
        var $finishButton = $('a[href="#finish"]').parent();
        var customTextFields = $('#fieldMappingsTable input[type="text"]');
        var validationError = null;
        
        for (var index = 0; index < customTextFields.length; index++) {
            var $customTextField = $(customTextFields[index]);
            var $row = $customTextField.closest('tr');
            var $fieldName = $row.find('td.field-name');
            var useCustom = $('#' + $fieldName.attr('data-field-key') + 'UseCustom:checked');
            
            if (useCustom.length > 0) {
                var error = validateTextField($customTextField, $row);
                
                if (!!error) {
                    $customTextField.addClass('invalid');
                    
                    if (!validationError) {
                        validationError = error;
                    }
                }
            } else {
                $customTextField.removeClass('invalid');
            }
        }
        
        if (!!validationError) {
            $.showErrorStatus(validationError);
        }
        
        return (!$finishButton.hasClass('invalid') && !validationError);
    };
    
    var wizardFinished = function(event, currentIndex) {
        var data = getData();
        
        if (!!originalName) {
            //it was an edit request
            updateRow(data);
        } else {
            //it was an add request
            addRow(data);
        }
        
        closeWizard();
    };
    
    var validateStepOne = function() {
        $.clearStatus();
        var stepIsValid = true;
        nameEdited = true;
        serverEdited = true;
        userIdEdited = true;
        passwordEdited = true;
        
                
        var errorText = validateName();
        var lastErrorMessage = null;
        
        if (errorText.trim().length > 0) {
           	lastErrorMessage = errorText;
        }
 
        errorText = validateServer();
        
       	if (lastErrorMessage === null) {
       		if (errorText.trim().length > 0) {
       			lastErrorMessage = errorText;
       		}
    	}
        
   		errorText = validateUserID();
   
       	if (lastErrorMessage === null) {
    		if (errorText.trim().length > 0) {
    			lastErrorMessage = errorText;
    		}
     	}
        
   		errorText = validatePassword();
        
       	if (lastErrorMessage === null) {
       		if (errorText.trim().length > 0) {
       			lastErrorMessage = errorText;
       		}
    	}
        
        $.clearStatus();
        if (lastErrorMessage !== null && lastErrorMessage.trim().length > 0) {
            stepIsValid = false;
            $.showErrorStatus(lastErrorMessage);
        }

        return stepIsValid;
    }
    
    var validateName = function(event) {
        var errorText = '';
        var $issueTrackingName = $('#issueTrackingName');
        var name = $issueTrackingName.val();
        
        if (name.length > 0) {
            if (name.search(/^\s/g) !== -1) {
                //starts with whitespace
                errorText = nameStartErrorText;
            } else if (name.search(/\s$/g) !== -1) {
                //ends with whitespace
                errorText = nameEndErrorText;
            } else {
                var newName = name.toLowerCase();
                
                if (!originalName || (newName !== originalName.toLowerCase())) {
                    if (!!issueTrackingNames) {
                        for (var index = 0; index <  issueTrackingNames.length; index++) {
                            var existingName = issueTrackingNames[index];
                            
                            if (existingName.toLowerCase() === newName) {
                                errorText = nameErrorText;
                                break;
                            }
                        }
                    }
                }
            }
        } else {
            errorText = nameRequiredErrorText;
        }
        
        if (!!event) {
            if (event.type === 'input') {
                //if this is an input event then the field value was edited
                nameEdited = true;
            }
            
            if (errorText.trim().length === 0) {
                //only clear the status on an event because the step validation
                //will clear it for us.
                $.clearStatus();
            }
        }
        
        if (errorText.trim().length > 0 && nameEdited) {
            if (!$issueTrackingName.hasClass('invalid')) {                
                $issueTrackingName.addClass('invalid');
            }
            
            $.showErrorStatus(errorText);
        } else {
            $issueTrackingName.removeClass('invalid');
        }
        
        return errorText;
    };
    
    var validateServer = function(event) {
        var errorText = '';
        $issueTrackingServer = $('#issueTrackingServer')
        var server = $('#issueTrackingServer').val();
        
        if (server.length > 0) {
            var whitespaceIndex = server.search(/\s/g);
            
            if (whitespaceIndex !== -1) {
                //whitespace was found
                errorText = serverErrorText;
            }
        } else {
            errorText = serverRequiredErrorText;
        }
        
        if (!!event) {
            if (event.type === 'input') {
                //if this is an input event then the field value was edited
                serverEdited = true;
            }
            
            if (errorText.trim().length === 0) {
                //only clear the status on an event because the step validation
                //will clear it for us.
                $.clearStatus();
            }
        }
        
        if (errorText.trim().length > 0 && serverEdited) {
            if (!$issueTrackingServer.hasClass('invalid')) {                
                $issueTrackingServer.addClass('invalid');
            }
            
            $.showErrorStatus(errorText);
        } else {
            $issueTrackingServer.removeClass('invalid');
        }
      
        return errorText;
    };
    
    var validateUserID = function(event) {
        var errorText = '';
        $issueTrackingUserID = $('#issueTrackingUserID')
        var userID = $issueTrackingUserID.val();
        
        if (userID.length > 0) {
            var whitespaceIndex = userID.search(/\s/g);
            
            if (whitespaceIndex !== -1) {
                //whitespace was found
                errorText = userIdErrorText;
            }
        } else {
            errorText = userIdRequiredErrorText;
        }
        
        if (!!event) {
            if (event.type === 'input') {
                //if this is an input event then the field value was edited
                userIdEdited = true;
            }
            
            if (errorText.trim().length === 0) {
                //only clear the status on an event because the step validation
                //will clear it for us.
                $.clearStatus();
            }
        }
        
        if (errorText.trim().length > 0 && userIdEdited) {
            if (!$issueTrackingUserID.hasClass('invalid')) {                
                $issueTrackingUserID.addClass('invalid');
            }
            
            $.showErrorStatus(errorText);
        } else {
            $issueTrackingUserID.removeClass('invalid');
        }
        
        return errorText;
    };
    
    var validatePassword = function(event) {
        var errorText = '';
        $issueTrackingPassword = $('#issueTrackingPassword')
        var password = $issueTrackingPassword.val();
        
        if (password.length > 0) {
            var whitespaceIndex = password.search(/\s/g);
            
            if (whitespaceIndex !== -1) {
                //whitespace was found
                errorText = passwordErrorText;
            }
        } else {
            errorText = passwordRequiredErrorText;
        }
        
        if (!!event) {
            if (event.type === 'input') {
                //if this is an input event then the field value was edited
                passwordEdited = true;
            }
            
            if (errorText.trim().length === 0) {
                //only clear the status on an event because the step validation
                //will clear it for us.
                $.clearStatus();
            }
        }
        
        if (errorText.trim().length > 0 && passwordEdited) {
            if (!$issueTrackingPassword.hasClass('invalid')) {                
                $issueTrackingPassword.addClass('invalid');
            }
            
           $.showErrorStatus(errorText);
        } else {
            $issueTrackingPassword.removeClass('invalid');
        }
        
        return errorText;
    };
    
    var clearFieldMappingsTable = function() {
        $('#fieldMappingsTable tbody').empty();
    };
    
    // The document has finished loading, let's do our stuff
    $(document).ready(function() {
        $.displayLoadingIndicator(loadingText, '.main-contents');
        jiraProjectsTemplate = $('#jiraProjectsTemplate').html().trim();
        jiraIssuesTemplate = $('#jiraIssuesTemplate').html().trim();
        fieldRowsTemplate = $('#fieldRowsTemplate').html().trim();
        tableHeaderTemplate = $('#tableHeaderTemplate').html().trim();
        tableFillerTemplate = $('#tableFillerTemplate').html().trim();
        
        $.when(
            $.ajax({
                type: 'GET',
                url : 'settings/getIssueTrackingTypes',
                dataType : 'json',
                cache : false
            }),                
            $.ajax({
                type: 'GET',
                url : 'settings/getIssueTrackingSystems',
                dataType : 'json',
                cache : false
            })                
        ).done(function(issueTrackingTypes, issueTrackingSystems) {
            var typesResponse = issueTrackingTypes[0];
            
            if (!!typesResponse) {
                if (!!typesResponse.success) {
                    var $typesSelect = $('#issueTrackingType');
                    
                    for (var index = 0; index < typesResponse.names.length; index++) {
                        var name = typesResponse.names[index];
                        $typesSelect.append('<option value="' + name + '">' + name + '</option>');
                    }
                }
            }
            
            var systemsResponse = issueTrackingSystems[0];
            var issueTrackingSystems = [];
            
            if (!!systemsResponse) {
                if (!!systemsResponse.IssueTrackingSystemInfoResponse) {
                    var systemInfoList = systemsResponse.IssueTrackingSystemInfoResponse.IssueTrackingSystemInfoList;
                    
                    for (var index = 0; index < systemInfoList.length; index++) {
                        var systemInfo = systemInfoList[index];
                        systemInfo = decryptPassword(systemInfo);
                        issueTrackingSystems.push(systemInfo);
                    }
                } else if (systemsResponse.returnCode != 0) {
                    $.showErrorStatus(systemsResponse.message + " (Return Code: " + systemsResponse.returnCode + ", Reason Code: " + systemsResponse.reasonCode + ")" );
                }
            }
                
            var headers = [{
                title : nameColumnHeaderText 
            }, {
                title : typeColumnHeaderText 
            }, {
                title : serverColumnHeaderText 
            }, {
                title : userColumnHeaderText 
            }];
             
            var issueTrackingTableOptions = {
                columns : [
                    {
                        data : 'name'
                    },
                    {
                        data : 'type'
                    },
                    {
                        data : 'server'
                    },
                    {
                        data : 'userID'
                    }
                ],
                order : [[0, 'asc']],
                data : issueTrackingSystems
            };
            
            var tableControls = {
                addButton : {
                    clazz : 'add-button',
                    callback : showIssueTrackingWizard
                },
                editButton : {
                    clazz : 'edit-button',
                    callback : showIssueTrackingWizard,
                    disabled : 'disabled',
                    enablement : 'single'
                },
                deleteButton : {
                    clazz : 'delete-button',
                    disabled : 'disabled',
                    enablement : 'multi',
                    deleteConfirmationCallback : deleteSelectedRows
                }  
            };
            
            var issueTrackingTableComponent = new SimpleTableComponent('issueTracking', '#issueTrackingTableContainer', headers);
            issueTrackingTable = issueTrackingTableComponent.createTable(issueTrackingTableOptions, 'multi', null, null, tableControls);            
        }).always(function() {
            $.removeLoadingIndicator();
            
            if ($('#issueTrackingType').find('option').length > 0) {
                $('.main-contents').show();
            } else {
                $.showMessageDialog({
                    title: errorResources.getValue('no.issue.tracking.systems'),
                    message: errorResources.getValue('no.systems.available'),
                    dialogID: '#errorDialog',
                    width: 'auto'
                });
            }
        });
    });        
})(jQuery);